<ng-container *transloco="let t; read: 'formFieldFile'" [formGroup]="parentFormGroup">
  <button mat-button type="button" color="primary" (click)="fileInput.click()">
    {{ selectedFiles.length > 0 ? selectedFiles : t('selectFile') }}
  </button>
  <input hidden type="file" #fileInput (change)="fileChanged($event)" [accept]="accept" [multiple]="field.multiple" />
</ng-container>
